import { ProductTypes, PRODUCT_TYPES } from 'Types/ProductTypes'
import i18n from 'Lib/i18n'

export const getProductName = (product?: ProductTypes): string => {
  const productName = product && product.toLowerCase()
  switch (productName) {
    case PRODUCT_TYPES.PAID_MARKETING:
    case PRODUCT_TYPES.BOT_ZAPPING:
      return i18n.t(`products_names.${productName}`, { ns: 'general' })
    default:
      return ''
  }
}
